import api from '../api'
import { fetchUser, clearBackupEmailInStore } from './user'
import { fetchMeta } from './meta'

export function fetchEmailVerificationPrompts(userId) {
  return (dispatch) => api.fetch(`/users/${userId}/email-verification/prompts`)
    .then((response) => {
      dispatch({ type: 'FETCH_EMAIL_VERIFICATION_PROMPTS_SUCCESS', response })
      return response
    })
    .catch(() => {})
}

// name = 'verifyPrimary' | 'affirmPrimary' | 'addBackup' | 'affirmBackup'
// data = { never?: true } — never: true means "don't ask me again" for this prompt
export function dismissEmailVerificationPrompt(userId, name, data) {
  return (dispatch) => api.put(`/users/${userId}/email-verification/prompts/${name}/dismiss`, data)
    .then((response) => {
      dispatch({ type: 'DISMISS_EMAIL_VERIFICATION_PROMPT_SUCCESS', name })
      // dismiss writes meta.emailVerificationPromptState (dismissedAt, and
      // addBackupDismissCount for addBackup) — refetch so "Don't ask me again"
      // sees the new count without a reload
      dispatch(fetchMeta())
      return response
    })
}

// data = { purpose: 'verifyPrimary' | 'updatePrimary' | 'upsertBackup', email?,
//          type?: 'password' | 'apple' | 'google', password?, idToken?, recaptchaResponse }
// → { id, purpose, expiresAt, resendAvailableAt }
export function createEmailVerification(userId, data) {
  return () => api.post(`/users/${userId}/email-verification`, data)
    .then((response) => response)
}

export function resendEmailVerification(userId, verificationId) {
  return () => api.post(`/users/${userId}/email-verification/${verificationId}/resend`)
    .then((response) => response)
}

// Affirms a previously-verified primary email whose confirmation has gone
// stale (the affirmPrimary prompt) — no code round trip. The caller should
// refetch prompts afterward to see whether addBackup is still due.
export function affirmPrimaryEmail(userId) {
  return (dispatch) => api.put(`/users/${userId}/email-verification/affirm-primary`)
    .then((response) => {
      // affirm updates meta.emailConfirmedAt, same as verify
      dispatch(fetchUser(userId))
      return response
    })
}

// Affirms a previously-verified backup email whose confirmation has gone
// stale (the affirmBackup prompt) — no code round trip, mirrors affirmPrimary.
export function affirmBackupEmail(userId) {
  return (dispatch) => api.put(`/users/${userId}/email-verification/affirm-backup`)
    .then((response) => {
      dispatch(fetchUser(userId))
      return response
    })
}

// → { status, attemptsRemaining, prompts, backupEmailRemoved }
export function verifyEmailVerification(userId, verificationId, code) {
  return (dispatch) => api.put(`/users/${userId}/email-verification/${verificationId}/verify`, { code })
    .then((response) => {
      dispatch({ type: 'VERIFY_EMAIL_VERIFICATION_SUCCESS', response })
      if (response.backupEmailRemoved) {
        clearBackupEmailInStore(dispatch)
      }
      // verify is the only writer of user.email / user.backupEmail / the confirm-verify
      // timestamps, so refresh the user record to pick up whatever changed.
      dispatch(fetchUser(userId))
      return response
    })
}
